import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { AssigmentDetailsComponent } from './components/details/assignment-details.component'
import { AssignmentsLayoutComponent } from './components/assignments-layout/assignments-layout.component'
import { AssignmentsPageComponent } from './components/assignments-page/assignments-page.component'
import { BilledAssignmentsPeriodComponent } from './components/billed-assignments-period/billed-assignments-period.component'
import { BilledAssignmentsComponent } from './components/billed-assignments/billed-assignments.component'
import { ExchangeAssignmentsComponent } from './components/exchange-assignments/exchange-assignments.component'
import { MyAssignmentsComponent } from './components/my-assignments/my-assignments.component'
import { OpenAssignmentsComponent } from './components/open-assignments/open-assignments.component'
import { PastAssignmentsComponent } from './components/past-assignments/past-assignments.component'

const routes: Routes = [
    {
        path: '',
        component: AssignmentsLayoutComponent,
        children: [
            {
                path: '',
                component: AssignmentsPageComponent,
            },
            {
                path: 'schedules',
                loadChildren: () => import('./assignment-schedules/assignment-schedule.module').then((m) => m.AssignmentScheduleModule),
            },
            {
                path: 'my',
                component: MyAssignmentsComponent,
            },
            {
                path: 'open',
                component: OpenAssignmentsComponent,
            },
            {
                path: 'exchange',
                component: ExchangeAssignmentsComponent,
            },
            {
                path: 'past',
                component: PastAssignmentsComponent,
            },
            {
                path: 'billed/:id',
                component: BilledAssignmentsPeriodComponent,
            },
            {
                path: 'billed',
                component: BilledAssignmentsComponent,
            },
            {
                path: ':id',
                component: AssigmentDetailsComponent,
            }
        ],
    },
]

@NgModule({
    imports: [CommonModule, RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AssignmentRoutingModule { }
